<script setup lang="ts">
import ListSkeleton from '@/components/library/skeleton/views/ListSkeleton.vue';

interface Props {
  skeletonCont: number;
}

withDefaults(defineProps<Props>(), {
  skeletonCont: 3,
});
</script>

<template>
  <ul class="rounded-lg panel-b-spacing bg-white">
    <list-skeleton
      v-for="n in skeletonCont"
      :key="'list-skeleton' + n"
      size="small"
    />
  </ul>
</template>
